export type TSchoolStatus = "setup" | "trial" | "active" | "disabled";
export type TUserRole = "admin" | "staff";
export type TActiveStatus = "active" | "disabled";
export type TDateFormat = 'mm/dd/yyyy' | 'yyyy-mm-dd' | 'MMM DD-YYYY';

export enum ModuleType {
    RESUME_BUILDER = "resume-builder",
    RESUME_SCANNER = "resume-scanner",
    COVERLETTER_BUILDER = "coverletter-builder",
    AUDIO_INTERVIEWS = "audio-interviews",
    VIDEO_INTERVIEWS = "video-interviews",
    COURSES = "courses",
    JOB_PORTAL = "job-portal",
    IMMIGRATION_ASSESSMENT = "immigration-assessment",
    STUDY_VISA_CHANCES = "study-visa-chances",
    STATUS_MANAGER = "status-manager",
    TRAVEL_LOG = "travel-log",
    AI_CHAT = "ai-chat",
    LIVE_SUPPORT = "live-support",
};

export enum ModuleFeatureValueType {
    BOOLEAN = "boolean",
    INTEGER = "integer",
};

export enum InterviewMode {
    VIDEO = "video",
    AUDIO = "audio",
};

export enum InterviewQuestionType {
    TECHNICAL = "technical",
    BEHAVIORAL = "behavioral",
    BOTH = "both",
};

export enum StudentOnboardingResponseOptionsField {
    CURRENT_STATUS = 'current_status',
    CAREER_INTEREST = 'career_interest',
    CURRENT_IMMIGRATION_STATUS = 'current_immigration_status',
    PROGRAM_OF_STUDY = 'program_of_study',
};